module.exports = __webpack_public_path__ + "static/img/key-warehouse-1.772471c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/key-warehouse-1.png
// module id = BWXe
// module chunks = 1